// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import ReferralTerms from "layouts/agreements/referral/ReferralTerms";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import Footer from "examples/Footer";

function Agree() {
  return (
    <>
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} pl={3}justifyContent="center">
          <Grid item xs={12} lg={8} pr={3} pb={3}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="body2"color="lightneutrals"> </MDTypography>
              <MDTypography align="center" variant="h5" color="soliddark">MyAgentFinder Referral Network</MDTypography>
            <MDTypography align = "center" variant="h5" color="soliddark">Agent Terms and Conditions</MDTypography>
              </MDBox>
              <MDBox pt={2} px={2} pb={3}>
              <ReferralTerms />
              </MDBox>
            </Card>

          </Grid>
        </Grid>
      </MDBox>
      <Grid pb={3} pl={4}item style={{ alignSelf: 'flex-start' }}>
                    <Footer />
      </Grid>
    </>
  );
}

export default Agree;
